import { Chip } from "primereact/chip";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";

export default function PessoaCadastralStandard({
  pessoaCadastralStandard
}: {
  pessoaCadastralStandard: any
}) {
  const { t } = useTranslation();
  let rg = null;
  if(pessoaCadastralStandard.BasicData && pessoaCadastralStandard.BasicData.AlternativeIdNumbers && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.AlternativeIdNumbers) && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.AlternativeIdNumbers).length > 0 && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.AlternativeIdNumbers).filter((s:string)=> s.includes('RG')).length > 0 && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.AlternativeIdNumbers).filter((s:string)=> s.includes('RG'))[0].includes('RG')){
    rg = pessoaCadastralStandard.BasicData.AlternativeIdNumbers[Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.AlternativeIdNumbers).filter((s:string)=> s.includes('RG'))[0]]
  }
  if(pessoaCadastralStandard.BasicData && pessoaCadastralStandard.BasicData.ExtendedDocumentInformation && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.ExtendedDocumentInformation) && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.ExtendedDocumentInformation).length > 0 && Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.ExtendedDocumentInformation)[0].includes('RG')){
    rg = rg + ' ' + pessoaCadastralStandard.BasicData.ExtendedDocumentInformation[Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.ExtendedDocumentInformation)[0]].DocumentIssuingAgency + ' - ' + pessoaCadastralStandard.BasicData.ExtendedDocumentInformation[Object.getOwnPropertyNames(pessoaCadastralStandard.BasicData.ExtendedDocumentInformation)[0]].DocumentIssuingStateCode
  }
return (
    <Panel header={t('pessoa')}>
      {pessoaCadastralStandard.message ? (<p>{pessoaCadastralStandard.message}</p>) : (<div>
        <div className="grid">
          <div className="col">
            <div >
                <label className="label-dados">{t('pis')}</label>
                <Chip style={{width:"100%"}} label={ pessoaCadastralStandard.BasicData.AlternativeIdNumbers?.SocialSecurityNumber ?? 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
                <label className="label-dados">{t('rg')}</label>
                <Chip style={{width:"100%"}} label={ rg ?? 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col">
            <div >
                <label className="label-dados">{t('nacionalidade')}</label>
                <Chip style={{width:"100%"}} label={ pessoaCadastralStandard.BasicData.BirthCountry ?? 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              
            </div>
          </div>
        </div>
        </div>)}
    </Panel>
)
}